import { defineStore } from "pinia";
import { EmailConfirmedListState } from "@core/store/types/admin/lists/EmailConfirmedListState";
import { GET_EMAIL_CONFIRMED } from "@core/store/action-constants";
import i18n from "@core/plugins/i18n";

export const useEmailConfirmedList = defineStore("admin/lists/emailConfirmedList", {
  state: (): EmailConfirmedListState => ({
    data: {}
  }),
    
  actions: {
    [GET_EMAIL_CONFIRMED] () {
      const items = [
        { label: i18n.t("admin.users.webmasters.filters.values.emailConfirmed"), value: true },
        { label: i18n.t("admin.users.webmasters.filters.values.emailUnConfirmed"), value: false }
      ];
      this.data = { items, count: items.length };
    }
  }
});